import React from 'react';
import { Center, Loader, Stack, Text } from '@mantine/core';

/**
 * Full-screen loading view shown while the application resolves
 * site configuration during startup.
 */
export default function LoadingScreen() {
  return (
    <Center w="100vw" h="100vh" role="status" aria-live="polite">
      <Stack align="center" gap="xs">
        <Loader size="lg" aria-label="Loading"/>
        <Text c="dimmed">Loading site configuration…</Text>
      </Stack>
    </Center>
  );
}
